var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "anon"
  }, [_vm._m(0), _c('ul', {
    staticClass: "anon-usps"
  }, _vm._l(_vm.usps, function (usp) {
    return _c('li', {
      key: usp.title
    }, [_c('span', {
      staticClass: "anon-usp-icon"
    }, [_c('img', {
      attrs: {
        "src": usp.icon,
        "alt": ""
      }
    })]), _c('strong', [_vm._v(_vm._s(usp.title))]), _c('small', [_vm._v(_vm._s(usp.text))])]);
  }), 0), _vm.subscription ? _c('div', {
    staticClass: "anon-active"
  }, [_c('div', [_c('span', {
    staticClass: "anon-active-label",
    class: {
      'is-cancelled': _vm.subscription.ending
    }
  }, [_vm._v(" " + _vm._s(_vm.subscription.ending ? "Subscription cancelled" : "Active subscription") + " ")]), _c('h3', [_vm._v(_vm._s(_vm.subscription.planName))]), _c('p', [_vm._v(" " + _vm._s(_vm.subscription.price) + " " + _vm._s(_vm.subscription.period) + " · started " + _vm._s(_vm.formatDate(_vm.subscription.startedAt)) + " "), _vm.subscription.retrying ? _c('span', {
    staticClass: "anon-retry"
  }, [_vm._v(" · payment failed, Stripe is retrying ")]) : _vm.subscription.ending ? _c('span', {
    staticClass: "anon-until"
  }, [_vm._v(" · will not renew, you keep access until " + _vm._s(_vm.formatDate(_vm.subscription.endsAt)) + " ")]) : _vm.subscription.endsAt ? _c('span', [_vm._v(" · renews " + _vm._s(_vm.formatDate(_vm.subscription.endsAt)) + " ")]) : _vm._e()])]), _vm.subscription.planId !== 'lifetime' ? [!_vm.subscription.ending ? _c('b-button', {
    staticClass: "anon-cancel",
    attrs: {
      "type": "button",
      "disabled": _vm.cancelling
    },
    on: {
      "click": _vm.cancelSubscription
    }
  }, [_vm._v(" " + _vm._s(_vm.cancelling ? "Cancelling…" : "Cancel Subscription") + " ")]) : _c('b-button', {
    staticClass: "anon-cancel anon-resume",
    attrs: {
      "type": "button",
      "disabled": _vm.cancelling
    },
    on: {
      "click": _vm.resumeSubscription
    }
  }, [_vm._v(" " + _vm._s(_vm.cancelling ? "Resuming…" : "Resume Subscription") + " ")])] : _vm._e()], 2) : _vm._e(), _vm.verifying ? _c('div', {
    staticClass: "anon-notice"
  }, [_vm._v(" Confirming your payment with Stripe… ")]) : _vm.cancelled ? _c('div', {
    staticClass: "anon-notice"
  }, [_vm._v(" Checkout cancelled — you have not been charged. ")]) : _vm.failed ? _c('div', {
    staticClass: "anon-alert"
  }, [_vm._v(" We could not confirm your payment. If you were charged it will appear here once Stripe settles — otherwise please try again. ")]) : _vm._e(), _c('div', {
    staticClass: "anon-plans"
  }, _vm._l(_vm.plans, function (plan) {
    return _c('div', {
      key: plan.id,
      staticClass: "anon-plan",
      class: {
        selected: _vm.selectedPlan === plan.id,
        disabled: _vm.isDisabled(plan)
      },
      on: {
        "click": function ($event) {
          return _vm.selectPlan(plan);
        }
      }
    }, [_c('div', {
      staticClass: "anon-plan-head"
    }, [_c('span', {
      staticClass: "anon-radio",
      class: {
        on: _vm.selectedPlan === plan.id
      }
    }), _c('h3', [_vm._v(_vm._s(plan.name))]), plan.badge ? _c('span', {
      staticClass: "anon-best"
    }, [_c('img', {
      attrs: {
        "src": "/assets/gifting/icon-crown.svg",
        "alt": ""
      }
    }), _vm._v(" " + _vm._s(plan.badge) + " ")]) : _vm._e()]), _c('div', {
      staticClass: "anon-price"
    }, [plan.price ? _c('strong', [_vm._v(_vm._s(plan.price))]) : _c('strong', {
      staticClass: "anon-price-empty"
    }, [_vm._v("—")]), _c('span', [_vm._v("/ " + _vm._s(plan.period))])]), _c('ul', {
      staticClass: "anon-perks"
    }, _vm._l(plan.perks, function (perk, index) {
      return _c('li', {
        key: index
      }, [_c('span', {
        staticClass: "anon-check"
      }), _vm._v(" " + _vm._s(perk) + " ")]);
    }), 0), _vm.isOwned(plan.id) ? _c('p', {
      staticClass: "anon-plan-note"
    }, [_vm._v(" " + _vm._s(_vm.subscription.ending ? ("Active until " + (_vm.formatDate(_vm.subscription.endsAt)) + ".") : "You are subscribed to this plan.") + " ")]) : _vm.isSuperseded(plan.id) ? _c('p', {
      staticClass: "anon-plan-note"
    }, [_vm._v(" Already included in your Lifetime plan. ")]) : _vm._e()]);
  }), 0), _c('div', {
    staticClass: "anon-cta-wrap"
  }, [_c('b-button', {
    staticClass: "anon-cta",
    attrs: {
      "type": "button",
      "disabled": _vm.ctaDisabled
    },
    on: {
      "click": _vm.continueToPayment
    }
  }, [_vm._v(" " + _vm._s(_vm.ctaLabel) + " ")]), _vm._m(1)], 1)]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "anon-hero"
  }, [_c('span', {
    staticClass: "anon-hero-badge"
  }, [_c('img', {
    attrs: {
      "src": "/assets/gifting/icon-premium.svg",
      "alt": ""
    }
  }), _vm._v(" Premium Feature ")]), _c('h2', [_vm._v("Anonymous "), _c('span', [_vm._v("Gifting")])]), _c('p', [_vm._v(" Send gifts without revealing your identity. Keep your profile private while spreading motivation. ")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('p', {
    staticClass: "anon-secure"
  }, [_c('img', {
    attrs: {
      "src": "/assets/gifting/icon-lock.svg",
      "alt": ""
    }
  }), _vm._v(" Secure payment powered by Stripe ")]);
}]

export { render, staticRenderFns }